<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.papeis"
                            @change="handlePapelChange"
                            default-option-text="Todos"
                            label="Papel"
                            show-default-option
                            text-field="nome"
                            v-model="model.papelId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.modulos"
                            @change="handleModuloChange"
                            default-option-text="Todos"
                            label="Módulo"
                            show-default-option
                            text-field="nome"
                            v-model="model.moduloId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.funcionalidades"
                            @change="handleFuncionalidadeChange"
                            default-option-text="Todas"
                            label="Funcionalidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.funcionalidadeId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.crudAcoes"
                            @change="handleCrudAcaoChange"
                            default-option-text="Todas"
                            label="Permissão para"
                            show-default-option
                            text-field="nome"
                            v-model="model.crudAcaoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.acoes"
                            @change="handleAcaoChange"
                            default-option-text="Todas"
                            label="Tipo de ação"
                            show-default-option
                            text-field="nome"
                            v-model="model.acaoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :repository="repositories.relatorioHistoricoPermissaoPapel.usuarioResponsavel"
                            :request-query-string-params="requestQueryStringParamsUsuarioResponsavel"
                            :search-fields="[{ key: 'cadastro_cidadao.nome', searchable: true }]"
                            label="Permitido por"
                            v-model="model.usuarioResponsavel"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="handleBuscarClick"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="handleLimparClick"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="handleImprimirClick"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
            />
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import {error, formats, object, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        validations() {
            return {
                periodo: { required: true },
            }
        },
        requestQueryStringParamsUsuarioResponsavel() {
            const request = this.clone(this.model)

            request.periodo.start = this.others.moment(this.model.periodo.start).format('DD/MM/YYYY')
            request.periodo.end = this.others.moment(this.model.periodo.end).format('DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(request)
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.administracao'),
            relatorioHistoricoPermissaoPapel: this.getConectaSusRepository('administracao.relatorioHistoricoPermissaoPapel'),
        }
    },
    data() {
        return {
            additionals: null,
            columns: [
                {
                    class: 'col-min text-center',
                    filterByFormatted: true,
                    fixed: true,
                    formatter: value => this.formatDateTime(value),
                    key: 'historicoDataHora',
                    label: 'Data/Hora',
                    sortable: true,
                },
                {key: 'papelNome', label: 'Papel', fixed: true, sortable: true },
                {key: 'moduloNome', label: 'Módulo', fixed: true, sortable: true },
                {key: 'funcionalidadeNome', label: 'Funcionalidade', fixed: true, sortable: true },
                {key: 'crudAcaoNome', label: 'Permissão para', fixed: true, sortable: true },
                {key: 'acaoNome', label: 'Tipo de ação', fixed: true, sortable: true },
                {key: 'usuarioResponsavelNome', label: 'Permitido por', sortable: true },
            ],
            form: null,
            indeterminate: true,
            itens: [],
            model: null,
            others: {moment},
            selectedAll: false,
            selectedColumns: [],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioHistoricoPermissaoPapel.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePapelChange() {
            this.form.modulos = []
            this.form.funcionalidades = []
            this.form.crudAcoes = []
            this.form.acoes = []
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.model.crudAcaoId = null
            this.model.acaoId = null

            this.model.usuarioResponsavel = {
                id: null,
                nome: null
            }

            this.itens = []

            this.getModulos()
        },
        handleModuloChange() {
            this.form.funcionalidades = []
            this.form.crudAcoes = []
            this.form.acoes = []
            this.model.funcionalidadeId = null
            this.model.crudAcaoId = null
            this.model.acaoId = null

            this.model.usuarioResponsavel = {
                id: null,
                nome: null
            }

            this.itens = []

            this.getFuncionalidades()
        },
        handleFuncionalidadeChange() {
            this.form.crudAcoes = []
            this.form.acoes = []
            this.model.crudAcaoId = null
            this.model.acaoId = null

            this.model.usuarioResponsavel = {
                id: null,
                nome: null
            }

            this.itens = []

            this.getCrudAcoes()
        },
        handleCrudAcaoChange() {
            this.form.acoes = []
            this.model.acaoId = null

            this.model.usuarioResponsavel = {
                id: null,
                nome: null
            }

            this.itens = []

            this.getAcoes()
        },
        handleAcaoChange() {
            this.model.usuarioResponsavel = {
                id: null,
                nome: null
            }

            this.itens = []
        },
        handleBuscarClick() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.itens = []

                    const request = this.clone(this.model)

                    request.periodo.start = this.others.moment(this.model.periodo.start).format('DD/MM/YYYY')
                    request.periodo.end = this.others.moment(this.model.periodo.end).format('DD/MM/YYYY')

                    this.setLoading()

                    this.repositories.relatorioHistoricoPermissaoPapel.index(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.itens = response.data
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleLimparClick() {
            this.form.papeis = []
            this.form.modulos = []
            this.form.funcionalidades = []
            this.form.crudAcoes = []
            this.form.acoes = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.papelId = null
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.model.crudAcaoId = null
            this.model.acaoId = null

            this.model.usuarioResponsavel = {
                id: null,
                nome: null
            }

            this.itens = []

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleImprimirClick() {
            this.setLoading()

            const request = {
                ...this.request(),
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.impressao.relatorioHistoricoPermissaoPapel(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        request() {
            const model = this.clone(this.model)

            model.periodo.start = this.others.moment(model.periodo.start).format('DD/MM/YYYY')
            model.periodo.end = this.others.moment(model.periodo.end).format('DD/MM/YYYY')

            return model
        },
        getPapeis() {
            this.setLoading()

            const request = {
                listar: 'papeis',
                ...this.request(),
            }

            this.repositories.relatorioHistoricoPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.papeis = Object.assign(response.data.papeis)
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                    this.form.crudAcoes = Object.assign(response.data.crudAcoes)
                    this.form.acoes = Object.assign(response.data.acoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getModulos() {
            this.setLoading()

            const request = {
                listar: 'modulos',
                ...this.request(),
            }

            this.repositories.relatorioHistoricoPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                    this.form.crudAcoes = Object.assign(response.data.crudAcoes)
                    this.form.acoes = Object.assign(response.data.acoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getFuncionalidades() {
            this.setLoading()

            const request = {
                listar: 'funcionalidades',
                ...this.request(),
            }

            this.repositories.relatorioHistoricoPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                    this.form.crudAcoes = Object.assign(response.data.crudAcoes)
                    this.form.acoes = Object.assign(response.data.acoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCrudAcoes() {
            this.setLoading()

            const request = {
                listar: 'crud-acoes',
                ...this.request(),
            }

            this.repositories.relatorioHistoricoPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.crudAcoes = Object.assign(response.data.crudAcoes)
                    this.form.acoes = Object.assign(response.data.acoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getAcoes() {
            this.setLoading()

            const request = {
                listar: 'acoes',
                ...this.request(),
            }

            this.repositories.relatorioHistoricoPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.acoes = Object.assign(response.data.acoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mounted() {
        this.load()
    },
    mixins: [error, formats, object, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.papeis = []
                this.form.modulos = []
                this.form.funcionalidades = []
                this.form.crudAcoes = []
                this.form.acoes = []
                this.model.papelId = null
                this.model.moduloId = null
                this.model.funcionalidadeId = null
                this.model.crudAcaoId = null
                this.model.acaoId = null

                this.model.usuarioResponsavel = {
                    id: null,
                    nome: null,
                }

                this.itens = []

                if (value.start && value.end) {
                    this.getPapeis()
                }
            },
        },
        'model.usuarioResponsavel': {
            deep: true,
            handler() {
                this.itens = []
            },
        },
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    },
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 300px;
}
</style>